import { forwardRef } from 'react';
import { clsx } from 'clsx';

interface IMapCanvasProps {
  /**
   * The styles classes to map around the map canvas container
   */
  className?: string;
}

/**
 * -----------------------------------------------------------------------------
 * This renders the component that will be used to display the underlying map.
 */
export const MapCanvas = forwardRef<HTMLDivElement, IMapCanvasProps>(
  ({ className }, ref) => (
    <div ref={ref} className={clsx('deprecated-map-container', className)} />
  )
);

MapCanvas.displayName = 'MapCanvas';
